import {times} from 'lodash'

export const NOTES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B']
const TONES = ['C', 'D', 'E', 'F', 'G', 'A', 'B']

const parseTuning = (str: string) => {
  const array = []
  for (let i = 0, l = str.length; i < l; i++) {
    const note = str[i].toUpperCase();
    if (TONES.indexOf(note) > -1) {
      const nextSymbol = str[i+1]
      if (nextSymbol === '#') {
        array.push(note + '#')
      } else {
        array.push(note)
      }
    }
  }
  return array
}

function* cycleArray(array: ReadonlyArray<any>){
  let index = 0;
  while (true) {
    yield array[index];
    index = (index+1)%array.length;
  }
}

function getGenerator(note: string, passFirstNote = true) {
  const indexOfNote = NOTES.indexOf(note)
  const index = passFirstNote ? indexOfNote + 1 : indexOfNote
  const generator = cycleArray(NOTES)
  times(index, () => generator.next())
  return generator
}

function generateScale (startingNote: string, scalePattern: ReadonlyArray<number>) {
  if (startingNote && scalePattern) {
    const generator = getGenerator(startingNote, false)
    const notes = scalePattern.map((n) => {
      times(n, () => generator.next())
      return generator.next().value
    })
    return notes
  } else {
    return []
  }
}

function shiftScale(scale: ReadonlyArray<string>, note: string | null) {
  if (!note || note === '---') { return [] }
  const noteIndex = scale.indexOf(note)
  const left = scale.slice(0, noteIndex)
  const right = scale.slice(noteIndex)
  return right.concat(left)
}

export {parseTuning, generateScale, shiftScale, getGenerator};



// WEBPACK FOOTER //
// ./src/modules/utils.ts